/* eslint-disable */
export const region12Barangays = [
    {
        CITY: 'ALABEL',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'ALABEL',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'ALABEL',
        BARANGAY: 'BALUNTAY',
    },
    {
        CITY: 'ALABEL',
        BARANGAY: 'DATAL ANGGAS',
    },
    {
        CITY: 'ALABEL',
        BARANGAY: 'DOMOLOK',
    },
    {
        CITY: 'ALABEL',
        BARANGAY: 'KAWAS',
    },
    {
        CITY: 'ALABEL',
        BARANGAY: 'LADOL',
    },
    {
        CITY: 'ALABEL',
        BARANGAY: 'MARIBULAN',
    },
    {
        CITY: 'ALABEL',
        BARANGAY: 'PAG-ASA',
    },
    {
        CITY: 'ALABEL',
        BARANGAY: 'PARAISO',
    },
    {
        CITY: 'ALABEL',
        BARANGAY: 'POBLACION (ALABEL)',
    },
    {
        CITY: 'ALABEL',
        BARANGAY: 'SPRING',
    },
    {
        CITY: 'ALABEL',
        BARANGAY: 'TOKAWAL',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'BALITON',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'BATOTULING',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'BATULAKI',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'BIG MARGUS',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'BURIAS',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'CABLALAN',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'CALABANIT',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'CALPIDONG',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'CONGAN',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'CROSS',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'DATALBUKAY',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'E. ALEGADO',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'GLAN PADIDU',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'GUMASA',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'ILAYA',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'KALTUAD',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'KAPATAN',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'LAGO',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'LAGUIMIT',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'MUDAN',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'NEW AKLAN',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'PANGYAN',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'RIO DEL PILAR',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'SMALL MARGUS',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'SUFATUBO',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'TALUYA',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'TANGO',
    },
    {
        CITY: 'GLAN',
        BARANGAY: 'TAPON',
    },
    {
        CITY: 'KIAMBA',
        BARANGAY: 'BADTASAN',
    },
    {
        CITY: 'KIAMBA',
        BARANGAY: 'DATU DANI',
    },
    {
        CITY: 'KIAMBA',
        BARANGAY: 'GASI',
    },
    {
        CITY: 'KIAMBA',
        BARANGAY: 'KAPATE',
    },
    {
        CITY: 'KIAMBA',
        BARANGAY: 'KATUBAO',
    },
    {
        CITY: 'KIAMBA',
        BARANGAY: 'KAYUPO',
    },
    {
        CITY: 'KIAMBA',
        BARANGAY: 'KLING (LUMIT)',
    },
    {
        CITY: 'KIAMBA',
        BARANGAY: 'LAGUNDI',
    },
    {
        CITY: 'KIAMBA',
        BARANGAY: 'LEBE',
    },
    {
        CITY: 'KIAMBA',
        BARANGAY: 'LOMUYON',
    },
    {
        CITY: 'KIAMBA',
        BARANGAY: 'LUMA',
    },
    {
        CITY: 'KIAMBA',
        BARANGAY: 'MALIGANG',
    },
    {
        CITY: 'KIAMBA',
        BARANGAY: 'NALUS',
    },
    {
        CITY: 'KIAMBA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'KIAMBA',
        BARANGAY: 'SALAKIT',
    },
    {
        CITY: 'KIAMBA',
        BARANGAY: 'SULI',
    },
    {
        CITY: 'KIAMBA',
        BARANGAY: 'TABLAO',
    },
    {
        CITY: 'KIAMBA',
        BARANGAY: 'TAMADANG',
    },
    {
        CITY: 'KIAMBA',
        BARANGAY: 'TAMBILIL',
    },
    {
        CITY: 'MAASIM',
        BARANGAY: 'AMSIPIT',
    },
    {
        CITY: 'MAASIM',
        BARANGAY: 'BALES',
    },
    {
        CITY: 'MAASIM',
        BARANGAY: 'COLON',
    },
    {
        CITY: 'MAASIM',
        BARANGAY: 'DALIAO',
    },
    {
        CITY: 'MAASIM',
        BARANGAY: 'KABATIOL',
    },
    {
        CITY: 'MAASIM',
        BARANGAY: 'KABLACAN',
    },
    {
        CITY: 'MAASIM',
        BARANGAY: 'KAMANGA',
    },
    {
        CITY: 'MAASIM',
        BARANGAY: 'KANALO',
    },
    {
        CITY: 'MAASIM',
        BARANGAY: 'LUMASAL',
    },
    {
        CITY: 'MAASIM',
        BARANGAY: 'LUMATIL',
    },
    {
        CITY: 'MAASIM',
        BARANGAY: 'MALBANG',
    },
    {
        CITY: 'MAASIM',
        BARANGAY: 'NOMOH',
    },
    {
        CITY: 'MAASIM',
        BARANGAY: 'PANANAG',
    },
    {
        CITY: 'MAASIM',
        BARANGAY: 'POBLACION (MAASIM)',
    },
    {
        CITY: 'MAASIM',
        BARANGAY: 'SEVEN HILLS',
    },
    {
        CITY: 'MAASIM',
        BARANGAY: 'TINOTO',
    },
    {
        CITY: 'MAITUM',
        BARANGAY: 'BATI-AN',
    },
    {
        CITY: 'MAITUM',
        BARANGAY: 'KALANEG',
    },
    {
        CITY: 'MAITUM',
        BARANGAY: 'KALAONG',
    },
    {
        CITY: 'MAITUM',
        BARANGAY: 'KIAMBING',
    },
    {
        CITY: 'MAITUM',
        BARANGAY: 'KIAYAP',
    },
    {
        CITY: 'MAITUM',
        BARANGAY: 'MABAY',
    },
    {
        CITY: 'MAITUM',
        BARANGAY: 'MAGULING',
    },
    {
        CITY: 'MAITUM',
        BARANGAY: 'MALALAG (POB.)',
    },
    {
        CITY: 'MAITUM',
        BARANGAY: 'MINDUPOK',
    },
    {
        CITY: 'MAITUM',
        BARANGAY: 'NEW LA UNION',
    },
    {
        CITY: 'MAITUM',
        BARANGAY: 'OLD POBLACION (MAITUM)',
    },
    {
        CITY: 'MAITUM',
        BARANGAY: 'PANGI (LINAO)',
    },
    {
        CITY: 'MAITUM',
        BARANGAY: 'PINOL',
    },
    {
        CITY: 'MAITUM',
        BARANGAY: 'SISON (EDENTON)',
    },
    {
        CITY: 'MAITUM',
        BARANGAY: 'TICULAB',
    },
    {
        CITY: 'MAITUM',
        BARANGAY: 'TUANADATU',
    },
    {
        CITY: 'MAITUM',
        BARANGAY: 'UPO (LANAO)',
    },
    {
        CITY: 'MAITUM',
        BARANGAY: 'WALI (KAMBUHAN)',
    },
    {
        CITY: 'MAITUM',
        BARANGAY: 'ZION',
    },
    {
        CITY: 'MALAPATAN',
        BARANGAY: 'DAAN SUYAN',
    },
    {
        CITY: 'MALAPATAN',
        BARANGAY: 'KIHAN',
    },
    {
        CITY: 'MALAPATAN',
        BARANGAY: 'KINAM',
    },
    {
        CITY: 'MALAPATAN',
        BARANGAY: 'LIBI',
    },
    {
        CITY: 'MALAPATAN',
        BARANGAY: 'LUN MASLA',
    },
    {
        CITY: 'MALAPATAN',
        BARANGAY: 'LUN PADIDU',
    },
    {
        CITY: 'MALAPATAN',
        BARANGAY: 'PATAG',
    },
    {
        CITY: 'MALAPATAN',
        BARANGAY: 'POBLACION (MALAPATAN)',
    },
    {
        CITY: 'MALAPATAN',
        BARANGAY: 'SAPU MASLA',
    },
    {
        CITY: 'MALAPATAN',
        BARANGAY: 'SAPU PADIDU',
    },
    {
        CITY: 'MALAPATAN',
        BARANGAY: 'TUYAN',
    },
    {
        CITY: 'MALAPATAN',
        BARANGAY: 'UPPER SUYAN',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'ALKIKAN',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'AMPON',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'ATLAE',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'BANAHAW',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'BANATE',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'BLAAN',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'B\'LAAN',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'DATAL BATONG',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'DATAL BILA',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'DATAL TAMPAL',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'J.P. LAUREL',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'KAWAYAN',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'KIBALA',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'KIBLAT',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'KINABALAN',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'LOWER MAINIT',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'LUTAY',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'MALABOD',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'MALALAG COGON',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'MALANDAG',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'MALUNGON GAMAY',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'NAGPAN',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'PANAMIN',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'TALUS',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'TAMBAN',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'UPPER BIANGAN',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'UPPER LUMABAT',
    },
    {
        CITY: 'MALUNGON',
        BARANGAY: 'UPPER MAINIT',
    },
    {
        CITY: 'GENERAL-SANTOS',
        BARANGAY: 'APOPONG',
    },
    {
        CITY: 'GENERAL-SANTOS',
        BARANGAY: 'BALUAN',
    },
    {
        CITY: 'GENERAL-SANTOS',
        BARANGAY: 'BATOMELONG',
    },
    {
        CITY: 'GENERAL-SANTOS',
        BARANGAY: 'BUAYAN',
    },
    {
        CITY: 'GENERAL-SANTOS',
        BARANGAY: 'BULA',
    },
    {
        CITY: 'GENERAL-SANTOS',
        BARANGAY: 'CALUMPANG',
    },
    {
        CITY: 'GENERAL-SANTOS',
        BARANGAY: 'CITY HEIGHTS',
    },
    {
        CITY: 'GENERAL-SANTOS',
        BARANGAY: 'CONEL',
    },
    {
        CITY: 'GENERAL-SANTOS',
        BARANGAY: 'DADIANGAS EAST (POB.)',
    },
    {
        CITY: 'GENERAL-SANTOS',
        BARANGAY: 'DADIANGAS NORTH',
    },
    {
        CITY: 'GENERAL-SANTOS',
        BARANGAY: 'DADIANGAS SOUTH',
    },
    {
        CITY: 'GENERAL-SANTOS',
        BARANGAY: 'DADIANGAS WEST',
    },
    {
        CITY: 'GENERAL-SANTOS',
        BARANGAY: 'FATIMA',
    },
    {
        CITY: 'GENERAL-SANTOS',
        BARANGAY: 'KATANGAWAN',
    },
    {
        CITY: 'GENERAL-SANTOS',
        BARANGAY: 'LABANGAL',
    },
    {
        CITY: 'GENERAL-SANTOS',
        BARANGAY: 'LAGAO (1ST & 3RD)',
    },
    {
        CITY: 'GENERAL-SANTOS',
        BARANGAY: 'LIGAYA',
    },
    {
        CITY: 'GENERAL-SANTOS',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'GENERAL-SANTOS',
        BARANGAY: 'OLYMPOG',
    },
    {
        CITY: 'GENERAL-SANTOS',
        BARANGAY: 'SAN ISIDRO (LAGAO 2ND)',
    },
    {
        CITY: 'GENERAL-SANTOS',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'GENERAL-SANTOS',
        BARANGAY: 'SIGUEL',
    },
    {
        CITY: 'GENERAL-SANTOS',
        BARANGAY: 'SINAWAL',
    },
    {
        CITY: 'GENERAL-SANTOS',
        BARANGAY: 'TAMBLER',
    },
    {
        CITY: 'GENERAL-SANTOS',
        BARANGAY: 'TINAGACAN',
    },
    {
        CITY: 'GENERAL-SANTOS',
        BARANGAY: 'UPPER LABAY',
    },
    {
        CITY: 'KORONADAL',
        BARANGAY: 'ASSUMPTION (BULOL)',
    },
    {
        CITY: 'KORONADAL',
        BARANGAY: 'AVANCENA (BO. 3)',
    },
    {
        CITY: 'KORONADAL',
        BARANGAY: 'CACUB',
    },
    {
        CITY: 'KORONADAL',
        BARANGAY: 'CALOOCAN',
    },
    {
        CITY: 'KORONADAL',
        BARANGAY: 'CARPENTER HILL',
    },
    {
        CITY: 'KORONADAL',
        BARANGAY: 'CONCEPCION (BO. 6)',
    },
    {
        CITY: 'KORONADAL',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'KORONADAL',
        BARANGAY: 'GENERAL PAULINO SANTOS (BO. 1)',
    },
    {
        CITY: 'KORONADAL',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'KORONADAL',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'KORONADAL',
        BARANGAY: 'MAMBUCAL',
    },
    {
        CITY: 'KORONADAL',
        BARANGAY: 'MORALES',
    },
    {
        CITY: 'KORONADAL',
        BARANGAY: 'NAMNAMA',
    },
    {
        CITY: 'KORONADAL',
        BARANGAY: 'NEW PANGASINAN (BO. 4)',
    },
    {
        CITY: 'KORONADAL',
        BARANGAY: 'PARAISO',
    },
    {
        CITY: 'KORONADAL',
        BARANGAY: 'ROTONDA',
    },
    {
        CITY: 'KORONADAL',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'KORONADAL',
        BARANGAY: 'SAN JOSE (BO. 5)',
    },
    {
        CITY: 'KORONADAL',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'KORONADAL',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'KORONADAL',
        BARANGAY: 'SANTO NINO (BO. 2)',
    },
    {
        CITY: 'KORONADAL',
        BARANGAY: 'SARABIA (BO. 8)',
    },
    {
        CITY: 'KORONADAL',
        BARANGAY: 'ZONE I (POB.)',
    },
    {
        CITY: 'KORONADAL',
        BARANGAY: 'ZONE II (POB.)',
    },
    {
        CITY: 'KORONADAL',
        BARANGAY: 'ZONE III (POB.)',
    },
    {
        CITY: 'KORONADAL',
        BARANGAY: 'ZONE IV (POB.)',
    },
    {
        CITY: 'KORONADAL',
        BARANGAY: 'ZULUETA (BO. 7)',
    },
    {
        CITY: 'LAKE-SEBU',
        BARANGAY: 'BACDULONG',
    },
    {
        CITY: 'LAKE-SEBU',
        BARANGAY: 'DENLAG',
    },
    {
        CITY: 'LAKE-SEBU',
        BARANGAY: 'HALILAN',
    },
    {
        CITY: 'LAKE-SEBU',
        BARANGAY: 'HANOON',
    },
    {
        CITY: 'LAKE-SEBU',
        BARANGAY: 'KLUBI',
    },
    {
        CITY: 'LAKE-SEBU',
        BARANGAY: 'LAKE LAHIT',
    },
    {
        CITY: 'LAKE-SEBU',
        BARANGAY: 'LAMCADE',
    },
    {
        CITY: 'LAKE-SEBU',
        BARANGAY: 'LAMDALAG',
    },
    {
        CITY: 'LAKE-SEBU',
        BARANGAY: 'LAMFUGON',
    },
    {
        CITY: 'LAKE-SEBU',
        BARANGAY: 'LAMLAHAK',
    },
    {
        CITY: 'LAKE-SEBU',
        BARANGAY: 'LOWER MACULAN',
    },
    {
        CITY: 'LAKE-SEBU',
        BARANGAY: 'LUHIB',
    },
    {
        CITY: 'LAKE-SEBU',
        BARANGAY: 'NED',
    },
    {
        CITY: 'LAKE-SEBU',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LAKE-SEBU',
        BARANGAY: 'SILUTON',
    },
    {
        CITY: 'LAKE-SEBU',
        BARANGAY: 'TAKUNEL',
    },
    {
        CITY: 'LAKE-SEBU',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'LAKE-SEBU',
        BARANGAY: 'TASIMAN',
    },
    {
        CITY: 'LAKE-SEBU',
        BARANGAY: 'UPPER MACULAN',
    },
    {
        CITY: 'NORALA',
        BARANGAY: 'BENIGNO AQUINO',
    },
    {
        CITY: 'NORALA',
        BARANGAY: 'BENIGNO AQUINO JR.',
    },
    {
        CITY: 'NORALA',
        BARANGAY: 'DUMAGUIL',
    },
    {
        CITY: 'NORALA',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'NORALA',
        BARANGAY: 'KIBID',
    },
    {
        CITY: 'NORALA',
        BARANGAY: 'LAPUZ',
    },
    {
        CITY: 'NORALA',
        BARANGAY: 'LIBERTY',
    },
    {
        CITY: 'NORALA',
        BARANGAY: 'LOPEZ JAENA',
    },
    {
        CITY: 'NORALA',
        BARANGAY: 'MATAPOL',
    },
    {
        CITY: 'NORALA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'NORALA',
        BARANGAY: 'PUTI',
    },
    {
        CITY: 'NORALA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'NORALA',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'NORALA',
        BARANGAY: 'SIMSIMAN',
    },
    {
        CITY: 'NORALA',
        BARANGAY: 'TINAGO',
    },
    {
        CITY: 'POLOMOLOK',
        BARANGAY: 'BENTUNG',
    },
    {
        CITY: 'POLOMOLOK',
        BARANGAY: 'CANNERY SITE',
    },
    {
        CITY: 'POLOMOLOK',
        BARANGAY: 'CROSSING PALKAN',
    },
    {
        CITY: 'POLOMOLOK',
        BARANGAY: 'GLAMANG',
    },
    {
        CITY: 'POLOMOLOK',
        BARANGAY: 'KINILIS',
    },
    {
        CITY: 'POLOMOLOK',
        BARANGAY: 'KLINAN 6',
    },
    {
        CITY: 'POLOMOLOK',
        BARANGAY: 'KORONADAL PROPER',
    },
    {
        CITY: 'POLOMOLOK',
        BARANGAY: 'LAM-CALIAF',
    },
    {
        CITY: 'POLOMOLOK',
        BARANGAY: 'LANDAN',
    },
    {
        CITY: 'POLOMOLOK',
        BARANGAY: 'LAPU',
    },
    {
        CITY: 'POLOMOLOK',
        BARANGAY: 'LUMAKIL',
    },
    {
        CITY: 'POLOMOLOK',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'POLOMOLOK',
        BARANGAY: 'MALIGO',
    },
    {
        CITY: 'POLOMOLOK',
        BARANGAY: 'PAGALUNGAN',
    },
    {
        CITY: 'POLOMOLOK',
        BARANGAY: 'PALKAN',
    },
    {
        CITY: 'POLOMOLOK',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'POLOMOLOK',
        BARANGAY: 'POLO',
    },
    {
        CITY: 'POLOMOLOK',
        BARANGAY: 'RUBBER',
    },
    {
        CITY: 'POLOMOLOK',
        BARANGAY: 'SILWAY 7',
    },
    {
        CITY: 'POLOMOLOK',
        BARANGAY: 'SILWAY 8',
    },
    {
        CITY: 'POLOMOLOK',
        BARANGAY: 'SULIT',
    },
    {
        CITY: 'POLOMOLOK',
        BARANGAY: 'SUMBAKIL',
    },
    {
        CITY: 'POLOMOLOK',
        BARANGAY: 'UPPER KLINAN',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'BENITEZ (POB.)',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'CABUDIAN',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'CABULING',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'CINCO (BARRIO 5)',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'DERILON',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'EL NONOK',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'IMPROGO VILLAGE (POB.)',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'KUSAN (BARRIO 8)',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'LAM-APOS',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'LAMBA',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'LAMBINGI',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'LAMPARI',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'LIWANAY (BARRIO 1)',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'MALAYA (BARRIO 9)',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'PUNONG GRANDE (BARRIO 2)',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'RANG-AY (BARRIO 4)',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'REYES (POB.)',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'RIZAL (BARRIO 3)',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'RIZAL POBLACION',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'SAN JOSE (BARRIO 7)',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'SAN VICENTE (BARRIO 6)',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'YANGCO POBLACION',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'AMBALGAN',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'GUINSANG-AN',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'MANUEL ROXAS',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'PANAY',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'SAJANEBA',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'TERESITA',
    },
    {
        CITY: 'SURALLAH',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'SURALLAH',
        BARANGAY: 'CANAHAY (GODWINO)',
    },
    {
        CITY: 'SURALLAH',
        BARANGAY: 'CENTRALA',
    },
    {
        CITY: 'SURALLAH',
        BARANGAY: 'COLONGULO',
    },
    {
        CITY: 'SURALLAH',
        BARANGAY: 'DAJAY',
    },
    {
        CITY: 'SURALLAH',
        BARANGAY: 'DUENGAS',
    },
    {
        CITY: 'SURALLAH',
        BARANGAY: 'LAMBONTONG',
    },
    {
        CITY: 'SURALLAH',
        BARANGAY: 'LAMIAN',
    },
    {
        CITY: 'SURALLAH',
        BARANGAY: 'LAMSUGOD',
    },
    {
        CITY: 'SURALLAH',
        BARANGAY: 'LIBERTAD (POB.)',
    },
    {
        CITY: 'SURALLAH',
        BARANGAY: 'LITTLE BAGUIO',
    },
    {
        CITY: 'SURALLAH',
        BARANGAY: 'MOLOY',
    },
    {
        CITY: 'SURALLAH',
        BARANGAY: 'NACI (DOCE)',
    },
    {
        CITY: 'SURALLAH',
        BARANGAY: 'TALAHIK',
    },
    {
        CITY: 'SURALLAH',
        BARANGAY: 'TUBIALA',
    },
    {
        CITY: 'SURALLAH',
        BARANGAY: 'UPPER SEPAKA',
    },
    {
        CITY: 'SURALLAH',
        BARANGAY: 'VETERANS',
    },
    {
        CITY: 'TAMPAKAN',
        BARANGAY: 'ALBAGAN',
    },
    {
        CITY: 'TAMPAKAN',
        BARANGAY: 'BUTO',
    },
    {
        CITY: 'TAMPAKAN',
        BARANGAY: 'DANLAG',
    },
    {
        CITY: 'TAMPAKAN',
        BARANGAY: 'KIPALBIG',
    },
    {
        CITY: 'TAMPAKAN',
        BARANGAY: 'LAMBAYONG',
    },
    {
        CITY: 'TAMPAKAN',
        BARANGAY: 'LAMPITAK',
    },
    {
        CITY: 'TAMPAKAN',
        BARANGAY: 'LIBERTY',
    },
    {
        CITY: 'TAMPAKAN',
        BARANGAY: 'MALTANA',
    },
    {
        CITY: 'TAMPAKAN',
        BARANGAY: 'PALO',
    },
    {
        CITY: 'TAMPAKAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TAMPAKAN',
        BARANGAY: 'PULA-BATO',
    },
    {
        CITY: 'TAMPAKAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'TAMPAKAN',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'TAMPAKAN',
        BARANGAY: 'TABLU',
    },
    {
        CITY: 'TANTANGAN',
        BARANGAY: 'BUKAY PAIT',
    },
    {
        CITY: 'TANTANGAN',
        BARANGAY: 'CABULING',
    },
    {
        CITY: 'TANTANGAN',
        BARANGAY: 'DUMADALIG',
    },
    {
        CITY: 'TANTANGAN',
        BARANGAY: 'LIBAS',
    },
    {
        CITY: 'TANTANGAN',
        BARANGAY: 'MAGON',
    },
    {
        CITY: 'TANTANGAN',
        BARANGAY: 'MAIBO',
    },
    {
        CITY: 'TANTANGAN',
        BARANGAY: 'MANGILALA',
    },
    {
        CITY: 'TANTANGAN',
        BARANGAY: 'NEW CUYAPO',
    },
    {
        CITY: 'TANTANGAN',
        BARANGAY: 'NEW ILOILO',
    },
    {
        CITY: 'TANTANGAN',
        BARANGAY: 'NEW LAMBUNAO',
    },
    {
        CITY: 'TANTANGAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TANTANGAN',
        BARANGAY: 'SAN FELIPE',
    },
    {
        CITY: 'TANTANGAN',
        BARANGAY: 'TINONGCOP',
    },
    {
        CITY: 'T\'BOLI',
        BARANGAY: 'AFLEK',
    },
    {
        CITY: 'T\'BOLI',
        BARANGAY: 'AFUS',
    },
    {
        CITY: 'T\'BOLI',
        BARANGAY: 'BASAG',
    },
    {
        CITY: 'T\'BOLI',
        BARANGAY: 'DATAL BOB',
    },
    {
        CITY: 'T\'BOLI',
        BARANGAY: 'DESAWO',
    },
    {
        CITY: 'T\'BOLI',
        BARANGAY: 'DLANAG',
    },
    {
        CITY: 'T\'BOLI',
        BARANGAY: 'EDWARDS',
    },
    {
        CITY: 'T\'BOLI',
        BARANGAY: 'EDWARDS (POB.)',
    },
    {
        CITY: 'T\'BOLI',
        BARANGAY: 'KEMATU',
    },
    {
        CITY: 'T\'BOLI',
        BARANGAY: 'LACONON',
    },
    {
        CITY: 'T\'BOLI',
        BARANGAY: 'LAMBANGAN',
    },
    {
        CITY: 'T\'BOLI',
        BARANGAY: 'LAMBULING',
    },
    {
        CITY: 'T\'BOLI',
        BARANGAY: 'LAMHAKO',
    },
    {
        CITY: 'T\'BOLI',
        BARANGAY: 'LAMSALOME',
    },
    {
        CITY: 'T\'BOLI',
        BARANGAY: 'LEMSNOLON',
    },
    {
        CITY: 'T\'BOLI',
        BARANGAY: 'MAAN',
    },
    {
        CITY: 'T\'BOLI',
        BARANGAY: 'MALUGONG',
    },
    {
        CITY: 'T\'BOLI',
        BARANGAY: 'MONGOCAYO',
    },
    {
        CITY: 'T\'BOLI',
        BARANGAY: 'NEW DUMANGAS',
    },
    {
        CITY: 'T\'BOLI',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'T\'BOLI',
        BARANGAY: 'SALACAFE',
    },
    {
        CITY: 'T\'BOLI',
        BARANGAY: 'SINOLON',
    },
    {
        CITY: 'T\'BOLI',
        BARANGAY: 'TALCON',
    },
    {
        CITY: 'T\'BOLI',
        BARANGAY: 'TALUFO',
    },
    {
        CITY: 'T\'BOLI',
        BARANGAY: 'TBOLOK',
    },
    {
        CITY: 'T\'BOLI',
        BARANGAY: 'T\'BOLOK',
    },
    {
        CITY: 'T\'BOLI',
        BARANGAY: 'TUDOK',
    },
    {
        CITY: 'TUPI',
        BARANGAY: 'ACMONAN',
    },
    {
        CITY: 'TUPI',
        BARANGAY: 'BOLOLMALA',
    },
    {
        CITY: 'TUPI',
        BARANGAY: 'BUNAO',
    },
    {
        CITY: 'TUPI',
        BARANGAY: 'CEBUANO',
    },
    {
        CITY: 'TUPI',
        BARANGAY: 'CROSSING RUBBER',
    },
    {
        CITY: 'TUPI',
        BARANGAY: 'KABLON',
    },
    {
        CITY: 'TUPI',
        BARANGAY: 'KALKAM',
    },
    {
        CITY: 'TUPI',
        BARANGAY: 'LINAN',
    },
    {
        CITY: 'TUPI',
        BARANGAY: 'LUNEN',
    },
    {
        CITY: 'TUPI',
        BARANGAY: 'MIASONG',
    },
    {
        CITY: 'TUPI',
        BARANGAY: 'PALIAN',
    },
    {
        CITY: 'TUPI',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TUPI',
        BARANGAY: 'POLONULING',
    },
    {
        CITY: 'TUPI',
        BARANGAY: 'SIMBO',
    },
    {
        CITY: 'TUPI',
        BARANGAY: 'TUBENG',
    },
    {
        CITY: 'BAGUMBAYAN',
        BARANGAY: 'BAI SARIFINANG',
    },
    {
        CITY: 'BAGUMBAYAN',
        BARANGAY: 'BIWANG',
    },
    {
        CITY: 'BAGUMBAYAN',
        BARANGAY: 'BUSOK',
    },
    {
        CITY: 'BAGUMBAYAN',
        BARANGAY: 'CHUA',
    },
    {
        CITY: 'BAGUMBAYAN',
        BARANGAY: 'DAGUMA',
    },
    {
        CITY: 'BAGUMBAYAN',
        BARANGAY: 'DALUGA',
    },
    {
        CITY: 'BAGUMBAYAN',
        BARANGAY: 'KABULANAN',
    },
    {
        CITY: 'BAGUMBAYAN',
        BARANGAY: 'KANULAY',
    },
    {
        CITY: 'BAGUMBAYAN',
        BARANGAY: 'KAPAYA',
    },
    {
        CITY: 'BAGUMBAYAN',
        BARANGAY: 'KINAYAO',
    },
    {
        CITY: 'BAGUMBAYAN',
        BARANGAY: 'MASIAG',
    },
    {
        CITY: 'BAGUMBAYAN',
        BARANGAY: 'MONTEVERDE',
    },
    {
        CITY: 'BAGUMBAYAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BAGUMBAYAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'BAGUMBAYAN',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'BAGUMBAYAN',
        BARANGAY: 'SISON',
    },
    {
        CITY: 'BAGUMBAYAN',
        BARANGAY: 'SOUTH SEPAKA',
    },
    {
        CITY: 'BAGUMBAYAN',
        BARANGAY: 'SUMILIL',
    },
    {
        CITY: 'BAGUMBAYAN',
        BARANGAY: 'TITULOK',
    },
    {
        CITY: 'BAGUMBAYAN',
        BARANGAY: 'TUKA',
    },
    {
        CITY: 'COLUMBIO',
        BARANGAY: 'BANTANGAN (LASAK)',
    },
    {
        CITY: 'COLUMBIO',
        BARANGAY: 'DATABLAO',
    },
    {
        CITY: 'COLUMBIO',
        BARANGAY: 'EDAY',
    },
    {
        CITY: 'COLUMBIO',
        BARANGAY: 'ELBEBE',
    },
    {
        CITY: 'COLUMBIO',
        BARANGAY: 'LASAK',
    },
    {
        CITY: 'COLUMBIO',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'COLUMBIO',
        BARANGAY: 'LOMOYON',
    },
    {
        CITY: 'COLUMBIO',
        BARANGAY: 'MAKAT (SUMALI PAS)',
    },
    {
        CITY: 'COLUMBIO',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'COLUMBIO',
        BARANGAY: 'MAYO',
    },
    {
        CITY: 'COLUMBIO',
        BARANGAY: 'NATIVIDAD',
    },
    {
        CITY: 'COLUMBIO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'COLUMBIO',
        BARANGAY: 'POLOMOLOK',
    },
    {
        CITY: 'COLUMBIO',
        BARANGAY: 'SINAPULAN',
    },
    {
        CITY: 'COLUMBIO',
        BARANGAY: 'SUCOB',
    },
    {
        CITY: 'COLUMBIO',
        BARANGAY: 'TELAFAS',
    },
    {
        CITY: 'ISULAN',
        BARANGAY: 'BAMBAD',
    },
    {
        CITY: 'ISULAN',
        BARANGAY: 'BUAL',
    },
    {
        CITY: 'ISULAN',
        BARANGAY: 'DANSULI',
    },
    {
        CITY: 'ISULAN',
        BARANGAY: 'D\'LOTILLA',
    },
    {
        CITY: 'ISULAN',
        BARANGAY: 'IMPAO',
    },
    {
        CITY: 'ISULAN',
        BARANGAY: 'KALAWAG I (POB.)',
    },
    {
        CITY: 'ISULAN',
        BARANGAY: 'KALAWAG II (POB.)',
    },
    {
        CITY: 'ISULAN',
        BARANGAY: 'KALAWAG III (POB.)',
    },
    {
        CITY: 'ISULAN',
        BARANGAY: 'KENRAM',
    },
    {
        CITY: 'ISULAN',
        BARANGAY: 'KOLAMBOG',
    },
    {
        CITY: 'ISULAN',
        BARANGAY: 'KUDANDING',
    },
    {
        CITY: 'ISULAN',
        BARANGAY: 'LAGANDANG',
    },
    {
        CITY: 'ISULAN',
        BARANGAY: 'LAGUILAYAN',
    },
    {
        CITY: 'ISULAN',
        BARANGAY: 'MAPANTIG',
    },
    {
        CITY: 'ISULAN',
        BARANGAY: 'NEW PANGASINAN',
    },
    {
        CITY: 'ISULAN',
        BARANGAY: 'SAMPAO',
    },
    {
        CITY: 'ISULAN',
        BARANGAY: 'TAYUGO',
    },
    {
        CITY: 'KALAMANSIG',
        BARANGAY: 'BANTOGON (SANTA CLARA)',
    },
    {
        CITY: 'KALAMANSIG',
        BARANGAY: 'CADIZ',
    },
    {
        CITY: 'KALAMANSIG',
        BARANGAY: 'DATU ITO ANDONG',
    },
    {
        CITY: 'KALAMANSIG',
        BARANGAY: 'DATU WASAY',
    },
    {
        CITY: 'KALAMANSIG',
        BARANGAY: 'DUMANGAS NUEVO',
    },
    {
        CITY: 'KALAMANSIG',
        BARANGAY: 'HINALAAN',
    },
    {
        CITY: 'KALAMANSIG',
        BARANGAY: 'LIMULAN',
    },
    {
        CITY: 'KALAMANSIG',
        BARANGAY: 'NALILIDAN',
    },
    {
        CITY: 'KALAMANSIG',
        BARANGAY: 'OBIAL',
    },
    {
        CITY: 'KALAMANSIG',
        BARANGAY: 'PAG-ASA',
    },
    {
        CITY: 'KALAMANSIG',
        BARANGAY: 'PARIL',
    },
    {
        CITY: 'KALAMANSIG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'KALAMANSIG',
        BARANGAY: 'SABANAL',
    },
    {
        CITY: 'KALAMANSIG',
        BARANGAY: 'SANGAY',
    },
    {
        CITY: 'KALAMANSIG',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'LAMBAYONG',
        BARANGAY: 'CARIDAD (CUYAPON)',
    },
    {
        CITY: 'LAMBAYONG',
        BARANGAY: 'DIDTARAS',
    },
    {
        CITY: 'LAMBAYONG',
        BARANGAY: 'GANSING (BILUMEN)',
    },
    {
        CITY: 'LAMBAYONG',
        BARANGAY: 'KABULAKAN',
    },
    {
        CITY: 'LAMBAYONG',
        BARANGAY: 'KAPINGKONG',
    },
    {
        CITY: 'LAMBAYONG',
        BARANGAY: 'KATITISAN',
    },
    {
        CITY: 'LAMBAYONG',
        BARANGAY: 'LAGAO',
    },
    {
        CITY: 'LAMBAYONG',
        BARANGAY: 'LILIT',
    },
    {
        CITY: 'LAMBAYONG',
        BARANGAY: 'MADANDING',
    },
    {
        CITY: 'LAMBAYONG',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'LAMBAYONG',
        BARANGAY: 'MAMALI',
    },
    {
        CITY: 'LAMBAYONG',
        BARANGAY: 'MATIOMPONG',
    },
    {
        CITY: 'LAMBAYONG',
        BARANGAY: 'MIDTAPOK',
    },
    {
        CITY: 'LAMBAYONG',
        BARANGAY: 'NEW CEBU',
    },
    {
        CITY: 'LAMBAYONG',
        BARANGAY: 'PALUMBI',
    },
    {
        CITY: 'LAMBAYONG',
        BARANGAY: 'PIDTIGUIAN',
    },
    {
        CITY: 'LAMBAYONG',
        BARANGAY: 'PIMBALAYAN',
    },
    {
        CITY: 'LAMBAYONG',
        BARANGAY: 'PINGUIAMAN',
    },
    {
        CITY: 'LAMBAYONG',
        BARANGAY: 'POBLACION (LAMBAYONG)',
    },
    {
        CITY: 'LAMBAYONG',
        BARANGAY: 'SADSALAN',
    },
    {
        CITY: 'LAMBAYONG',
        BARANGAY: 'SENEBEN',
    },
    {
        CITY: 'LAMBAYONG',
        BARANGAY: 'SIGAYAN',
    },
    {
        CITY: 'LAMBAYONG',
        BARANGAY: 'TAMBAK',
    },
    {
        CITY: 'LAMBAYONG',
        BARANGAY: 'TINUMIGUES',
    },
    {
        CITY: 'LAMBAYONG',
        BARANGAY: 'TUMIAO (TINAGA)',
    },
    {
        CITY: 'LAMBAYONG',
        BARANGAY: 'UDTONG',
    },
    {
        CITY: 'LEBAK',
        BARANGAY: 'AURELIO F. FREIRES (POBLACION II)',
    },
    {
        CITY: 'LEBAK',
        BARANGAY: 'BARURAO',
    },
    {
        CITY: 'LEBAK',
        BARANGAY: 'BARURAO II',
    },
    {
        CITY: 'LEBAK',
        BARANGAY: 'BASAK',
    },
    {
        CITY: 'LEBAK',
        BARANGAY: 'BOLEBOK',
    },
    {
        CITY: 'LEBAK',
        BARANGAY: 'BULULAWAN',
    },
    {
        CITY: 'LEBAK',
        BARANGAY: 'CAPILAN',
    },
    {
        CITY: 'LEBAK',
        BARANGAY: 'CHRISTIANNUEVO',
    },
    {
        CITY: 'LEBAK',
        BARANGAY: 'DATU KARON',
    },
    {
        CITY: 'LEBAK',
        BARANGAY: 'KALAMONGOG',
    },
    {
        CITY: 'LEBAK',
        BARANGAY: 'KEYTODAC',
    },
    {
        CITY: 'LEBAK',
        BARANGAY: 'KINODALAN',
    },
    {
        CITY: 'LEBAK',
        BARANGAY: 'NEW CALINOG',
    },
    {
        CITY: 'LEBAK',
        BARANGAY: 'NULING',
    },
    {
        CITY: 'LEBAK',
        BARANGAY: 'PANSUD',
    },
    {
        CITY: 'LEBAK',
        BARANGAY: 'PASANDALAN',
    },
    {
        CITY: 'LEBAK',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LEBAK',
        BARANGAY: 'POBLACION III',
    },
    {
        CITY: 'LEBAK',
        BARANGAY: 'POLOY-POLOY',
    },
    {
        CITY: 'LEBAK',
        BARANGAY: 'PURIKAY',
    },
    {
        CITY: 'LEBAK',
        BARANGAY: 'RAGANDANG',
    },
    {
        CITY: 'LEBAK',
        BARANGAY: 'SALAMAN',
    },
    {
        CITY: 'LEBAK',
        BARANGAY: 'SALANGSANG',
    },
    {
        CITY: 'LEBAK',
        BARANGAY: 'TAGUISA',
    },
    {
        CITY: 'LEBAK',
        BARANGAY: 'TIBPUAN',
    },
    {
        CITY: 'LEBAK',
        BARANGAY: 'TRAN',
    },
    {
        CITY: 'LEBAK',
        BARANGAY: 'VILLAMONTE',
    },
    {
        CITY: 'LUTAYAN',
        BARANGAY: 'ANTONG',
    },
    {
        CITY: 'LUTAYAN',
        BARANGAY: 'BAYASONG',
    },
    {
        CITY: 'LUTAYAN',
        BARANGAY: 'BLINGKONG',
    },
    {
        CITY: 'LUTAYAN',
        BARANGAY: 'LUTAYAN PROPER',
    },
    {
        CITY: 'LUTAYAN',
        BARANGAY: 'MAINDANG',
    },
    {
        CITY: 'LUTAYAN',
        BARANGAY: 'MAMALI',
    },
    {
        CITY: 'LUTAYAN',
        BARANGAY: 'MANILI',
    },
    {
        CITY: 'LUTAYAN',
        BARANGAY: 'PALAVILLA',
    },
    {
        CITY: 'LUTAYAN',
        BARANGAY: 'SAMPAO',
    },
    {
        CITY: 'LUTAYAN',
        BARANGAY: 'SISIMAN',
    },
    {
        CITY: 'LUTAYAN',
        BARANGAY: 'TAMNAG (POB.)',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'AKOL',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'BADIANGON',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'BALIANGO',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'BALWAN (BULAN)',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'BAMBANEN',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'BARANAYAN',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'BARONGIS',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'BATANG-BAGLAS',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'BUTRIL',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'COLOBE (TAGADTAL)',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'DATU MAGUIALES',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'DOMOLOL',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'KABULING',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'KALIBUHAN',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'KANIPAAN',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'KIDAYAN',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'KIPONGET',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'KISEK',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'KRAAN',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'KULONG-KULONG',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'LANGALI',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'LIBUA',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'LIGAO',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'LOPOKEN (LEPOLON)',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'LUMITAN',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'MAGANAO',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'MAGUID',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'MALATUNENG (MALATUNOL)',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'MALISBONG',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'MEDOL',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'MILBUK',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'MINA',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'MOLON',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'NAMAT MASLA',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'NAPNAPON',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'TIBUHOL (EAST BADIANGON)',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'WAL',
    },
    {
        CITY: 'PALIMBANG',
        BARANGAY: 'WASAG',
    },
    {
        CITY: 'PRESIDENT-QUIRINO',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'PRESIDENT-QUIRINO',
        BARANGAY: 'BANNAWAG',
    },
    {
        CITY: 'PRESIDENT-QUIRINO',
        BARANGAY: 'BAYAWA',
    },
    {
        CITY: 'PRESIDENT-QUIRINO',
        BARANGAY: 'C. MANGILALA',
    },
    {
        CITY: 'PRESIDENT-QUIRINO',
        BARANGAY: 'ESTRELLA',
    },
    {
        CITY: 'PRESIDENT-QUIRINO',
        BARANGAY: 'KALANAWE I',
    },
    {
        CITY: 'PRESIDENT-QUIRINO',
        BARANGAY: 'KALANAWE II',
    },
    {
        CITY: 'PRESIDENT-QUIRINO',
        BARANGAY: 'KATICO',
    },
    {
        CITY: 'PRESIDENT-QUIRINO',
        BARANGAY: 'MALINGON',
    },
    {
        CITY: 'PRESIDENT-QUIRINO',
        BARANGAY: 'MANGALEN',
    },
    {
        CITY: 'PRESIDENT-QUIRINO',
        BARANGAY: 'PEDTUBO',
    },
    {
        CITY: 'PRESIDENT-QUIRINO',
        BARANGAY: 'POBLACION (SAMBULAWAN)',
    },
    {
        CITY: 'PRESIDENT-QUIRINO',
        BARANGAY: 'ROMUALDEZ',
    },
    {
        CITY: 'PRESIDENT-QUIRINO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'PRESIDENT-QUIRINO',
        BARANGAY: 'SAN PEDRO (TUATO)',
    },
    {
        CITY: 'PRESIDENT-QUIRINO',
        BARANGAY: 'SINAKULAY',
    },
    {
        CITY: 'PRESIDENT-QUIRINO',
        BARANGAY: 'SUBEN',
    },
    {
        CITY: 'PRESIDENT-QUIRINO',
        BARANGAY: 'TINAUNGAN',
    },
    {
        CITY: 'PRESIDENT-QUIRINO',
        BARANGAY: 'TUAL (LIGUASAN)',
    },
    {
        CITY: 'SEN.-NINOY-AQUINO',
        BARANGAY: 'BANALI',
    },
    {
        CITY: 'SEN.-NINOY-AQUINO',
        BARANGAY: 'BASAG',
    },
    {
        CITY: 'SEN.-NINOY-AQUINO',
        BARANGAY: 'BUENAFLORES',
    },
    {
        CITY: 'SEN.-NINOY-AQUINO',
        BARANGAY: 'BUGSO',
    },
    {
        CITY: 'SEN.-NINOY-AQUINO',
        BARANGAY: 'BUKLOD',
    },
    {
        CITY: 'SEN.-NINOY-AQUINO',
        BARANGAY: 'GAPOK',
    },
    {
        CITY: 'SEN.-NINOY-AQUINO',
        BARANGAY: 'KADI',
    },
    {
        CITY: 'SEN.-NINOY-AQUINO',
        BARANGAY: 'KAPATAGAN',
    },
    {
        CITY: 'SEN.-NINOY-AQUINO',
        BARANGAY: 'KIADSAM',
    },
    {
        CITY: 'SEN.-NINOY-AQUINO',
        BARANGAY: 'KUDEN',
    },
    {
        CITY: 'SEN.-NINOY-AQUINO',
        BARANGAY: 'KULAMAN',
    },
    {
        CITY: 'SEN.-NINOY-AQUINO',
        BARANGAY: 'LAGUBANG',
    },
    {
        CITY: 'SEN.-NINOY-AQUINO',
        BARANGAY: 'LANGGAL',
    },
    {
        CITY: 'SEN.-NINOY-AQUINO',
        BARANGAY: 'LIMUHAY',
    },
    {
        CITY: 'SEN.-NINOY-AQUINO',
        BARANGAY: 'MALEGDEG',
    },
    {
        CITY: 'SEN.-NINOY-AQUINO',
        BARANGAY: 'MIDTUNGOK',
    },
    {
        CITY: 'SEN.-NINOY-AQUINO',
        BARANGAY: 'NATI',
    },
    {
        CITY: 'SEN.-NINOY-AQUINO',
        BARANGAY: 'SEWOD',
    },
    {
        CITY: 'SEN.-NINOY-AQUINO',
        BARANGAY: 'TACUPIS',
    },
    {
        CITY: 'SEN.-NINOY-AQUINO',
        BARANGAY: 'TINALON',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'ALA',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'DALADAP',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'DUKAY',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'GUIAMALIA',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'ILIAN',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'KANGKONG',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'LAGUINDING',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'MARGUES',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'NEW PANAY',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'NUMO',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'PAITAN',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'PAMANTINGAN',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'SAGASA',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'SALABACA',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'SALIAO',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'SALUMPING',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'VILLAMOR',
    },
    {
        CITY: 'TACURONG',
        BARANGAY: 'BARAS',
    },
    {
        CITY: 'TACURONG',
        BARANGAY: 'BUENAFLOR',
    },
    {
        CITY: 'TACURONG',
        BARANGAY: 'CALEAN',
    },
    {
        CITY: 'TACURONG',
        BARANGAY: 'CARMEN',
    },
    {
        CITY: 'TACURONG',
        BARANGAY: 'D\'LEDESMA',
    },
    {
        CITY: 'TACURONG',
        BARANGAY: 'GANSING',
    },
    {
        CITY: 'TACURONG',
        BARANGAY: 'KALANDAGAN',
    },
    {
        CITY: 'TACURONG',
        BARANGAY: 'LANCHETA',
    },
    {
        CITY: 'TACURONG',
        BARANGAY: 'LOWER KATUNGAL',
    },
    {
        CITY: 'TACURONG',
        BARANGAY: 'NEW ISABELA',
    },
    {
        CITY: 'TACURONG',
        BARANGAY: 'NEW LAGAO',
    },
    {
        CITY: 'TACURONG',
        BARANGAY: 'NEW PASSI',
    },
    {
        CITY: 'TACURONG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TACURONG',
        BARANGAY: 'RAJAH NUDA',
    },
    {
        CITY: 'TACURONG',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'TACURONG',
        BARANGAY: 'SAN EMMANUEL',
    },
    {
        CITY: 'TACURONG',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'TACURONG',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'TACURONG',
        BARANGAY: 'TINA',
    },
    {
        CITY: 'TACURONG',
        BARANGAY: 'UPPER KATUNGAL',
    },
    {
        CITY: 'ALAMADA',
        BARANGAY: 'BAO',
    },
    {
        CITY: 'ALAMADA',
        BARANGAY: 'BARANGIRAN',
    },
    {
        CITY: 'ALAMADA',
        BARANGAY: 'CAMANSI',
    },
    {
        CITY: 'ALAMADA',
        BARANGAY: 'DADO',
    },
    {
        CITY: 'ALAMADA',
        BARANGAY: 'GUILING',
    },
    {
        CITY: 'ALAMADA',
        BARANGAY: 'KITACUBONG (POB.)',
    },
    {
        CITY: 'ALAMADA',
        BARANGAY: 'LOWER DADO',
    },
    {
        CITY: 'ALAMADA',
        BARANGAY: 'MACABASA',
    },
    {
        CITY: 'ALAMADA',
        BARANGAY: 'MALITUBOG',
    },
    {
        CITY: 'ALAMADA',
        BARANGAY: 'MAPUROK',
    },
    {
        CITY: 'ALAMADA',
        BARANGAY: 'MIRASOL',
    },
    {
        CITY: 'ALAMADA',
        BARANGAY: 'PACAO',
    },
    {
        CITY: 'ALAMADA',
        BARANGAY: 'PARUAYAN',
    },
    {
        CITY: 'ALAMADA',
        BARANGAY: 'PIGCAWARAN',
    },
    {
        CITY: 'ALAMADA',
        BARANGAY: 'POLAYAGAN',
    },
    {
        CITY: 'ALAMADA',
        BARANGAY: 'RANGAYEN',
    },
    {
        CITY: 'ALAMADA',
        BARANGAY: 'RARADANGAN',
    },
    {
        CITY: 'ALEOSAN',
        BARANGAY: 'BAGOLIBAS',
    },
    {
        CITY: 'ALEOSAN',
        BARANGAY: 'CAWILIHAN',
    },
    {
        CITY: 'ALEOSAN',
        BARANGAY: 'DUALING',
    },
    {
        CITY: 'ALEOSAN',
        BARANGAY: 'DUNGUAN',
    },
    {
        CITY: 'ALEOSAN',
        BARANGAY: 'KATALICANAN',
    },
    {
        CITY: 'ALEOSAN',
        BARANGAY: 'LAWILI',
    },
    {
        CITY: 'ALEOSAN',
        BARANGAY: 'LOWER MINGADING',
    },
    {
        CITY: 'ALEOSAN',
        BARANGAY: 'LUANAN',
    },
    {
        CITY: 'ALEOSAN',
        BARANGAY: 'MALAPANG',
    },
    {
        CITY: 'ALEOSAN',
        BARANGAY: 'NEW LEON',
    },
    {
        CITY: 'ALEOSAN',
        BARANGAY: 'NEW PANAY',
    },
    {
        CITY: 'ALEOSAN',
        BARANGAY: 'PAGANGAN',
    },
    {
        CITY: 'ALEOSAN',
        BARANGAY: 'PALACAT',
    },
    {
        CITY: 'ALEOSAN',
        BARANGAY: 'PENTIL',
    },
    {
        CITY: 'ALEOSAN',
        BARANGAY: 'SAN MATEO',
    },
    {
        CITY: 'ALEOSAN',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'ALEOSAN',
        BARANGAY: 'TAPODOC',
    },
    {
        CITY: 'ALEOSAN',
        BARANGAY: 'TOMADO',
    },
    {
        CITY: 'ALEOSAN',
        BARANGAY: 'UPPER MINGADING',
    },
    {
        CITY: 'ANTIPAS',
        BARANGAY: 'B. CADUNGON',
    },
    {
        CITY: 'ANTIPAS',
        BARANGAY: 'CAMUTAN',
    },
    {
        CITY: 'ANTIPAS',
        BARANGAY: 'CANAAN',
    },
    {
        CITY: 'ANTIPAS',
        BARANGAY: 'DATU AGOD',
    },
    {
        CITY: 'ANTIPAS',
        BARANGAY: 'DOLORES',
    },
    {
        CITY: 'ANTIPAS',
        BARANGAY: 'KIYAAB',
    },
    {
        CITY: 'ANTIPAS',
        BARANGAY: 'LUHONG',
    },
    {
        CITY: 'ANTIPAS',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'ANTIPAS',
        BARANGAY: 'MALANGAG',
    },
    {
        CITY: 'ANTIPAS',
        BARANGAY: 'MALATAD',
    },
    {
        CITY: 'ANTIPAS',
        BARANGAY: 'MALIRE',
    },
    {
        CITY: 'ANTIPAS',
        BARANGAY: 'NEW PONTEVEDRA',
    },
    {
        CITY: 'ANTIPAS',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ARAKAN',
        BARANGAY: 'ALLAB',
    },
    {
        CITY: 'ARAKAN',
        BARANGAY: 'ANAPOLON',
    },
    {
        CITY: 'ARAKAN',
        BARANGAY: 'BADIANGON',
    },
    {
        CITY: 'ARAKAN',
        BARANGAY: 'BINOONGAN',
    },
    {
        CITY: 'ARAKAN',
        BARANGAY: 'DALLAG',
    },
    {
        CITY: 'ARAKAN',
        BARANGAY: 'DATU LADAYON',
    },
    {
        CITY: 'ARAKAN',
        BARANGAY: 'DATU MATANGKIL',
    },
    {
        CITY: 'ARAKAN',
        BARANGAY: 'DOROLUMAN',
    },
    {
        CITY: 'ARAKAN',
        BARANGAY: 'GAMBODES',
    },
    {
        CITY: 'ARAKAN',
        BARANGAY: 'GANATAN',
    },
    {
        CITY: 'ARAKAN',
        BARANGAY: 'GREENFIELD',
    },
    {
        CITY: 'ARAKAN',
        BARANGAY: 'KABALANTIAN',
    },
    {
        CITY: 'ARAKAN',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'ARAKAN',
        BARANGAY: 'KINAWAYAN',
    },
    {
        CITY: 'ARAKAN',
        BARANGAY: 'KULAMAN VALLEY',
    },
    {
        CITY: 'ARAKAN',
        BARANGAY: 'LANAO KURAN',
    },
    {
        CITY: 'ARAKAN',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'ARAKAN',
        BARANGAY: 'MAKALANGOT',
    },
    {
        CITY: 'ARAKAN',
        BARANGAY: 'MALIBATUAN',
    },
    {
        CITY: 'ARAKAN',
        BARANGAY: 'MARIA CARIDAD',
    },
    {
        CITY: 'ARAKAN',
        BARANGAY: 'MEOCAN',
    },
    {
        CITY: 'ARAKAN',
        BARANGAY: 'NAJE',
    },
    {
        CITY: 'ARAKAN',
        BARANGAY: 'NAPALICO',
    },
    {
        CITY: 'ARAKAN',
        BARANGAY: 'SALASANG',
    },
    {
        CITY: 'ARAKAN',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'ARAKAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'ARAKAN',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'ARAKAN',
        BARANGAY: 'SUMALILI',
    },
    {
        CITY: 'ARAKAN',
        BARANGAY: 'TUMANDING',
    },
    {
        CITY: 'BANISILAN',
        BARANGAY: 'BANISILAN POBLACION',
    },
    {
        CITY: 'BANISILAN',
        BARANGAY: 'BUSAON',
    },
    {
        CITY: 'BANISILAN',
        BARANGAY: 'CAPAYANGAN',
    },
    {
        CITY: 'BANISILAN',
        BARANGAY: 'CARUGMANAN',
    },
    {
        CITY: 'BANISILAN',
        BARANGAY: 'GASTAY',
    },
    {
        CITY: 'BANISILAN',
        BARANGAY: 'KALAWAIG',
    },
    {
        CITY: 'BANISILAN',
        BARANGAY: 'KIARING',
    },
    {
        CITY: 'BANISILAN',
        BARANGAY: 'MALAGAP',
    },
    {
        CITY: 'BANISILAN',
        BARANGAY: 'MALINAO',
    },
    {
        CITY: 'BANISILAN',
        BARANGAY: 'MIGUEL MACASARTE',
    },
    {
        CITY: 'BANISILAN',
        BARANGAY: 'PANTAR',
    },
    {
        CITY: 'BANISILAN',
        BARANGAY: 'PARADISE',
    },
    {
        CITY: 'BANISILAN',
        BARANGAY: 'PINAMULAAN',
    },
    {
        CITY: 'BANISILAN',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'BANISILAN',
        BARANGAY: 'PUTING-BATO',
    },
    {
        CITY: 'BANISILAN',
        BARANGAY: 'SOLAMA',
    },
    {
        CITY: 'BANISILAN',
        BARANGAY: 'THAILAND',
    },
    {
        CITY: 'BANISILAN',
        BARANGAY: 'TINIMBACAN',
    },
    {
        CITY: 'BANISILAN',
        BARANGAY: 'TUMBAO-CAMALIG',
    },
    {
        CITY: 'BANISILAN',
        BARANGAY: 'WADYA',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'BAGUA',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'BAGUA I',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'BAGUA II',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'BAGUA III',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'KALANGANAN',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'KALANGANAN I',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'KALANGANAN II',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'POBLACION III',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'POBLACION IV',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'POBLACION IX',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'POBLACION V',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'POBLACION VI',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'POBLACION VII',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'POBLACION VIII',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'ROSARY HEIGHTS',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'ROSARY HEIGHTS I',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'ROSARY HEIGHTS II',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'ROSARY HEIGHTS III',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'ROSARY HEIGHTS IV',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'ROSARY HEIGHTS IX',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'ROSARY HEIGHTS V',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'ROSARY HEIGHTS VI',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'ROSARY HEIGHTS VII',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'ROSARY HEIGHTS VIII',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'ROSARY HEIGHTS X',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'ROSARY HEIGHTS XI',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'ROSARY HEIGHTS XII',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'ROSARY HEIGHTS XIII',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'TAMONTAKA',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'TAMONTAKA I',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'TAMONTAKA II',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'TAMONTAKA III',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'TAMONTAKA IV',
    },
    {
        CITY: 'COTABATO',
        BARANGAY: 'TAMONTAKA V',
    },
    {
        CITY: 'KABACAN',
        BARANGAY: 'ARINGAY',
    },
    {
        CITY: 'KABACAN',
        BARANGAY: 'BANGILAN',
    },
    {
        CITY: 'KABACAN',
        BARANGAY: 'BANNAWAG',
    },
    {
        CITY: 'KABACAN',
        BARANGAY: 'BULUAN',
    },
    {
        CITY: 'KABACAN',
        BARANGAY: 'CUYAPON',
    },
    {
        CITY: 'KABACAN',
        BARANGAY: 'DAGUPAN',
    },
    {
        CITY: 'KABACAN',
        BARANGAY: 'KATIDTUAN',
    },
    {
        CITY: 'KABACAN',
        BARANGAY: 'KAYAGA',
    },
    {
        CITY: 'KABACAN',
        BARANGAY: 'KILAGASAN',
    },
    {
        CITY: 'KABACAN',
        BARANGAY: 'MAGATOS',
    },
    {
        CITY: 'KABACAN',
        BARANGAY: 'MALAMOTE',
    },
    {
        CITY: 'KABACAN',
        BARANGAY: 'MALANDUAGUE',
    },
    {
        CITY: 'KABACAN',
        BARANGAY: 'NANGA-AN',
    },
    {
        CITY: 'KABACAN',
        BARANGAY: 'OSIAS',
    },
    {
        CITY: 'KABACAN',
        BARANGAY: 'PAATAN LOWER',
    },
    {
        CITY: 'KABACAN',
        BARANGAY: 'PAATAN UPPER',
    },
    {
        CITY: 'KABACAN',
        BARANGAY: 'PEDTAD',
    },
    {
        CITY: 'KABACAN',
        BARANGAY: 'PISAN',
    },
    {
        CITY: 'KABACAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'KABACAN',
        BARANGAY: 'SALAPUNGAN',
    },
    {
        CITY: 'KABACAN',
        BARANGAY: 'SANGGADONG',
    },
    {
        CITY: 'KABACAN',
        BARANGAY: 'SIMBUHAY',
    },
    {
        CITY: 'KABACAN',
        BARANGAY: 'SIMONE',
    },
    {
        CITY: 'KABACAN',
        BARANGAY: 'TAMPED',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'AMAS',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'AMAZION',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'BALABAG',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'BALINDOG',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'BENOLIGAN',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'BERADA',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'GAYOLA',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'GINATILAN',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'ILOMAVIS',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'INDANGAN',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'JUNCTION',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'KALAISAN',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'KALASUYAN',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'LANAO',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'LINANGCOB',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'LUVIMIN',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'MACABOLIG',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'MALINAN',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'MANONGOL',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'MARBEL (EMBAC)',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'MATEO',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'MEOCHAO',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'MUA-AN',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'NEW BOHOL',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'NUANGAN',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'ONICA',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'PACO',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'PATADON (PATADON EAST)',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'PEREZ',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'SIBAWAN',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'SIKITAN',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'SINGAO',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'SUDAPIN',
    },
    {
        CITY: 'KIDAPAWAN',
        BARANGAY: 'SUMBAO',
    },
    {
        CITY: 'LIBUNGAN',
        BARANGAY: 'ABAGA',
    },
    {
        CITY: 'LIBUNGAN',
        BARANGAY: 'BAGUER',
    },
    {
        CITY: 'LIBUNGAN',
        BARANGAY: 'BARONGIS',
    },
    {
        CITY: 'LIBUNGAN',
        BARANGAY: 'BATIOCAN',
    },
    {
        CITY: 'LIBUNGAN',
        BARANGAY: 'CABARUYAN',
    },
    {
        CITY: 'LIBUNGAN',
        BARANGAY: 'CABPANGI',
    },
    {
        CITY: 'LIBUNGAN',
        BARANGAY: 'DEMAPACO',
    },
    {
        CITY: 'LIBUNGAN',
        BARANGAY: 'GREBONA',
    },
    {
        CITY: 'LIBUNGAN',
        BARANGAY: 'GUMAGA',
    },
    {
        CITY: 'LIBUNGAN',
        BARANGAY: 'KAPAYAWI',
    },
    {
        CITY: 'LIBUNGAN',
        BARANGAY: 'KILOYAO',
    },
    {
        CITY: 'LIBUNGAN',
        BARANGAY: 'KITUBOD',
    },
    {
        CITY: 'LIBUNGAN',
        BARANGAY: 'MALENGEN',
    },
    {
        CITY: 'LIBUNGAN',
        BARANGAY: 'MONTAY',
    },
    {
        CITY: 'LIBUNGAN',
        BARANGAY: 'NICA-AN',
    },
    {
        CITY: 'LIBUNGAN',
        BARANGAY: 'PALAO',
    },
    {
        CITY: 'LIBUNGAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LIBUNGAN',
        BARANGAY: 'SINAPANGAN',
    },
    {
        CITY: 'LIBUNGAN',
        BARANGAY: 'SINAWINGAN',
    },
    {
        CITY: 'LIBUNGAN',
        BARANGAY: 'ULAMIAN',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'ALIBAYON',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'AMABEL',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'BALETE',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'BANGKAL',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'BANTAC',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'BASAK',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'BINAY',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'BONGOLANON',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'DATU CELO',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'DOLES',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'DON PANACA',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'GUBATAN',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'ILIAN',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'IMAMALING',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'INAC',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'KAMADA',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'KAUSWAGAN',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'KINARUM',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'KISANDAL',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'MAGCAALAM',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'MAHONGCOG',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'MANOBISA',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'MANOBO',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'NOA',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'OWAS',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'PANGAO-AN',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'SALLAB',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'TAGBAC',
    },
    {
        CITY: 'MAGPET',
        BARANGAY: 'TEMPORAN',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'BATASAN',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'BIANGAN',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'BUENA VIDA',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'BUHAY',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'BULAKANON',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'CABILAO',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'DAGUPAN',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'GARSIKA',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'GUANGAN',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'INDANGAN',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'JOSE RIZAL',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'KATIPUNAN II',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'KAWAYANON',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'KISANTE',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'LEBOCE',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'LUAYON',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'LUNA NORTE',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'LUNA SUR',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'MALABUAN',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'MALASILA',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'MALUNGON',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'NEW BAGUIO',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'NEW BULATUKAN',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'NEW CEBU',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'NEW ISRAEL',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'OLD BULATUKAN',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'RODERO',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'SAGUING',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'SANTA FELOMINA',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'SINKATULAN',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'TALUNTALUNAN',
    },
    {
        CITY: 'MAKILALA',
        BARANGAY: 'VILLAFLORES',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'ARAKAN',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'BANGBANG',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'CENTRAL MALAMOTE',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'DALAPITAN',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'ESTADO',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'ILIAN',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'KABULACAN',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'KIBIA',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'KIBUDOC',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'KIDAMA',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'KILADA',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'LAMPAYAN',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'LATAGAN',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'LINAO',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'LOWER MALAMOTE',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'MANUBUAN',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'MANUPAL',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'MARBEL',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'MINAMAING',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'NATUTUNGAN',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'NEW ABRA',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'NEW ALIMODIAN',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'NEW BUGASONG',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'NEW PANDAN',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'PATADON WEST',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'PINAMATON',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'SARAYAN',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'TACULEN',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'TAGURANAO',
    },
    {
        CITY: 'MATALAM',
        BARANGAY: 'TAMPED (TAMPAD)',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'AGRICULTURE',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'ANONANG',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'ARIZONA',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'BAGUMBA',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'BALIKI',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'BARANGAY POBLACION 1',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'BARANGAY POBLACION 2',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'BARANGAY POBLACION 3',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'BARANGAY POBLACION 4',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'BARANGAY POBLACION 5',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'BARANGAY POBLACION 6',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'BARANGAY POBLACION 7',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'BARANGAY POBLACION 8',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'BITOKA',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'BUAL NORTE',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'BUAL SUR',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'BULANAN UPPER',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'CENTRAL BULANAN',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'CENTRAL GLAD',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'CENTRAL KATINGAWAN',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'CENTRAL LABAS',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'DAMATULAN',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'ILBOCEAN',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'KADIGASAN',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'KADINGILAN',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'KAPINPILAN',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'KIMAGANGO',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'KIWANAN',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'KUDARANGAN',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'LAGUMBINGAN',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'LOMOPOG',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'LOWER GLAD',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'LOWER KATINGAWAN',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'MACASENDEG',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'MALAMOTE',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'MALINGAO',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'MILAYA',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'MUDSENG',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'NABALAWAG',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'NALIN',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'NES',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'OLANDANG',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'PALONGOGUEN',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'PATINDEGUEN',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'RANGABAN',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'SADAAN',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'SALUNAYAN',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'SAMBULAWAN',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'TUGAL',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'TUMBRAS',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'UPPER GLAD I',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'UPPER GLAD II',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'UPPER LABAS',
    },
    {
        CITY: 'MIDSAYAP',
        BARANGAY: 'VILLARICA',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'BAGONTAPAY',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'BIALONG',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'BUAYAN',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'CALUNASAN',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'DAGONG',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'DALIPE',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'DUGONG',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'DUNGO-AN',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'GAUNAN',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'INAS',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'LA FORTUNA',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'LA SUERTE',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'LANGKONG',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'LEPAGA',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'LIBOO',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'LIKA',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'LUZ VILLAGE',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'MAGALLON',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'MALAYAN',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'NEW ANTIQUE',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'NEW BARBAZA',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'NEW CONSOLACION',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'NEW ESPERANZA',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'NEW JANIUAY',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'NEW KALIBO',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'NEW LAWA-AN',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'NEW RIZAL',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'NUEVA VIDA',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'PAG-ASA',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'PALMA-PEREZ',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'POBLACION A',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'POBLACION B',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'PULANG-LUPA',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'SANGAT',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'TAWANTAWAN',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'TIBAO',
    },
    {
        CITY: 'M\'LANG',
        BARANGAY: 'UGPAY',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'AROMAN',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'BENTANGAN',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'CADIIS',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'GENERAL LUNA',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'KATANAYANAN',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'KIB-AYAO',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'KIBENES',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'KIBUGTONGAN',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'KILALA',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'KIMADZIL',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'KITULAAN',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'LANGOGAN',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'LANOON',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'LILIONGAN',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'MACABENBAN',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'MALAPAG',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'MANARAPAN',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'MANILI',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'NASAPIAN',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'PALANGGALAN',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'PEBPOLOAN',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'RANZO',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'TACUPAN',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'TAMBAD',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'TONGANON',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'TUPIG',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'UGALINGAN (LUMAYONG)',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'BATO-BATO',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'CABANGBANGAN',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'CAMASI',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'DATU INDANG',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'DATU SANDONGAN',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'DEL CARMEN',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'F. CAJELO (NEW MAASIN)',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'GREENHILL',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'IDAOMAN',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'ILUSTRE',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'KAMARAHAN',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'KIMARUHING',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'KISUPAAN',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'LA ESPERANZA',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'LABU-O',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'LAMALAMA',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'LOMONAY',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'NEW CEBU',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'SAGCUNGAN',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'SALAT',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'SARAYAN',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'TUAEL',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'ANICK (UPPER BALOGO)',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'BALACAYON',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'BALOGO',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'BANUCAGON',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'BULUAN',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'BULUCAON',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'BURICAIN',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'CABPANGI',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'CAPAYURAN',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'CENTRAL PANATAN',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'DATU BINASING',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'DATU MANTIL',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'KADINGILAN',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'KIMARAYANG',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'LIBUNGAN TORRETA',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'LOWER BAGUER',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'LOWER PANGANGKALAN',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'MALAGAKIT',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'MALUAO',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'MATILAC',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'MIDPAPAN I',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'MIDPAPAN II',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'MULOK',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'NEW CULASI',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'NEW IGBARAS',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'NEW PANAY',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'NORTH MANUANGAN',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'PATOT',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'PAYONG-PAYONG',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'POBLACION III',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'PRESBITERO',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'RENIBON',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'SIMSIMAN',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'SOUTH MANUANGAN',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'TIGBAWAN',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'TUBON',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'UPPER BAGUER (BAGUER)',
    },
    {
        CITY: 'PIGKAWAYAN',
        BARANGAY: 'UPPER PANGANGKALAN',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'BAGOAINGUD (BAGOINGED)',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'BALABAK',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'BALATICAN',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'BALONG',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'BALUNGIS',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'BARUNGIS',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'BATULAWAN',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'BUALAN',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'BULIOK',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'BULOD',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'BULOL',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'CALAWAG',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'DALINGAOEN (LALINGAON)',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'DAMALASAK',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'FORT PIKIT',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'GINATILAN',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'GLIGLI',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'GOKOTON (GOKOTAN)',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'INUG-UG',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'KABASALAN',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'KALACACAN',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'KATILACAN',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'KOLAMBOG',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'LADTINGAN',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'LAGUNDE',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'LANGAYEN',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'MACABUAL',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'MACASENDEG',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'MANAULANAN',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'NABUNDAS',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'NALAPAAN',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'NUNGUAN',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'PAIDU PULANGI',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'PAMALIAN',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'PANICUPAN',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'PUNOL',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'RAJAH MUDA',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'SILIK',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'TAKIPAN',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'TALITAY',
    },
    {
        CITY: 'PIKIT',
        BARANGAY: 'TINUTULAN',
    },
    {
        CITY: 'TULUNAN',
        BARANGAY: 'BACONG',
    },
    {
        CITY: 'TULUNAN',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'TULUNAN',
        BARANGAY: 'BANAYAL',
    },
    {
        CITY: 'TULUNAN',
        BARANGAY: 'BATANG',
    },
    {
        CITY: 'TULUNAN',
        BARANGAY: 'BITUAN',
    },
    {
        CITY: 'TULUNAN',
        BARANGAY: 'BUAL',
    },
    {
        CITY: 'TULUNAN',
        BARANGAY: 'BUNAWAN',
    },
    {
        CITY: 'TULUNAN',
        BARANGAY: 'DAIG',
    },
    {
        CITY: 'TULUNAN',
        BARANGAY: 'DAMAWATO',
    },
    {
        CITY: 'TULUNAN',
        BARANGAY: 'DUNGOS',
    },
    {
        CITY: 'TULUNAN',
        BARANGAY: 'F. CAJELO',
    },
    {
        CITY: 'TULUNAN',
        BARANGAY: 'GALIDAN',
    },
    {
        CITY: 'TULUNAN',
        BARANGAY: 'GENOVEVA BAYNOSA',
    },
    {
        CITY: 'TULUNAN',
        BARANGAY: 'KANIBONG',
    },
    {
        CITY: 'TULUNAN',
        BARANGAY: 'LA ESPERANZA',
    },
    {
        CITY: 'TULUNAN',
        BARANGAY: 'LAMPAGANG',
    },
    {
        CITY: 'TULUNAN',
        BARANGAY: 'MAGBOK',
    },
    {
        CITY: 'TULUNAN',
        BARANGAY: 'MAYBULA',
    },
    {
        CITY: 'TULUNAN',
        BARANGAY: 'MINAPAN',
    },
    {
        CITY: 'TULUNAN',
        BARANGAY: 'NABUNDASAN',
    },
    {
        CITY: 'TULUNAN',
        BARANGAY: 'NEW CARIDAD',
    },
    {
        CITY: 'TULUNAN',
        BARANGAY: 'NEW CULASI',
    },
    {
        CITY: 'TULUNAN',
        BARANGAY: 'NEW PANAY',
    },
    {
        CITY: 'TULUNAN',
        BARANGAY: 'PARAISO',
    },
    {
        CITY: 'TULUNAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TULUNAN',
        BARANGAY: 'POPOYON',
    },
    {
        CITY: 'TULUNAN',
        BARANGAY: 'SIBSIB',
    },
    {
        CITY: 'TULUNAN',
        BARANGAY: 'TAMBAC',
    },
    {
        CITY: 'TULUNAN',
        BARANGAY: 'TUBURAN',
    }
];
